import { render, staticRenderFns } from "./RsaDiagnosiConcomitantiModalComponent.vue?vue&type=template&id=8b8dffb0&scoped=true"
import script from "./RsaDiagnosiConcomitantiModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaDiagnosiConcomitantiModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaDiagnosiConcomitantiModalComponent.vue?vue&type=style&index=0&id=8b8dffb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8dffb0",
  null
  
)

export default component.exports